'use strict';
import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
@Component({
    selector: 'dot-loader',
    template: '<div class="dot" *ngFor="let i of numDots"></div>',
})
export class DotLoaderComponent implements OnChanges {
    numDots: Array<string>
    @Input() dots: number
    constructor() {}

    ngOnChanges(changes: SimpleChanges) {
        this.numDots = [];
        this.numDots[this.dots-1] = '';
    }
}



// WEBPACK FOOTER //
// ./_src/ui/elements/dotLoader.ts